module.exports = __webpack_public_path__ + "assets/img/1014.46b26313.png";